// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root, body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin: 0;
}

a {
  text-decoration: none;
  color: var(--theme-accent-color);
}
`, "",{"version":3,"sources":["webpack://./src/root.css"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC","sourcesContent":["\n:root, body {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  margin: 0;\n}\n\na {\n  text-decoration: none;\n  color: var(--theme-accent-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
